import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import addUser from "../Images/add-user.svg";
import * as Yup from "yup";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useFormik } from "formik";
import { path_url } from "../Config/config";
import logo from "../Images/warning_sign.jpg";
import "../Style/Password_warning.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { faRepeat, faCheck, faXmark, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

// Password strength requirements
const passwordRequirements = [
  { key: "minLength", label: "Minimum 8 characters", test: (val) => val && val.length >= 8 },
  { key: "uppercase", label: "At least one uppercase letter (A-Z)", test: (val) => /[A-Z]/.test(val) },
  { key: "lowercase", label: "At least one lowercase letter (a-z)", test: (val) => /[a-z]/.test(val) },
  { key: "number", label: "At least one number (0-9)", test: (val) => /[0-9]/.test(val) },
  { key: "special", label: "At least one special character (@, #, $, %, &, *)", test: (val) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(val) },
];

export default function Register() {
  const [capsLockOn, setCapsLockOn] = useState(false);
  const [capsLockonregister, SetCapsLockonregister] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const generateRandomCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captcha = "";
    for (let i = 0; i < 6; i++) {
      captcha += characters.charAt(
        Math.floor(Math.random() * characters.length),
      );
    }
    return captcha;
  };

  const [captchaCode, setCaptchaCode] = useState(generateRandomCaptcha());
  const navigate = useNavigate();
  const handleReloadCaptcha = () => {
    setCaptchaCode(generateRandomCaptcha());
  };
  const handleKeyDown = (event) => {
    if (event.getModifierState("CapsLock")) {
      setCapsLockOn(true);
    } else {
      setCapsLockOn(false);
    }
  };

  const handleKeyUp = (event) => {
    if (!event.getModifierState("CapsLock")) {
      setCapsLockOn(false);
    }
  };
  const handleKeyDownregister = (event) => {
    if (event.getModifierState("CapsLock")) {
      SetCapsLockonregister(true);
    } else {
      SetCapsLockonregister(false);
    }
  };

  const handleKeyUpregister = (event) => {
    if (!event.getModifierState("CapsLock")) {
      SetCapsLockonregister(false);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .min(2, "Name must be at least 2 characters")
      .max(50, "Name must not exceed 50 characters"),
    email: Yup.string()
      .required("Email is required")
      .email("Invalid email format"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(40, "Password must not exceed 40 characters")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/,
        "Password must contain at least one special character (e.g., @, #, $, %, &, *)"
      ),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
    captcha: Yup.string().required("Captcha is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      usertype: "student",
      email: "",
      password: "",
      confirmPassword: "",
      captcha: "",
    },
    validationSchema,
    onSubmit: async (values, { setSubmitting, setStatus }) => {
      console.log(values);
      if (values.captcha === captchaCode) {
        // delete values.captcha;
        try {
          const response = await axios.post(`${path_url}/register`, values);

          if (response.data.statusCodeValue === 200) {
            toast.success("Registration successful! Account has been created successfully. You can now log in.");
            setTimeout(() => {
              navigate("/login");
            }, 3000);
          } else {
            toast.error(response.data.body);
            handleReloadCaptcha();
          }
        } catch (error) {
          const msg =
            error.response?.data?.message ||
            error.response?.data?.body ||
            "Server is unreachable. Please ensure the backend is running.";
          toast.error(msg);
        } finally {
          setSubmitting(false);
        }
      } else {
        toast.error("Incorrect captcha. Please try again.");
        formik.setFieldValue("captcha", "");
        handleReloadCaptcha();
      }
    },
  });

  return (
    <>
      <SEO  
        title="Register for AI ERP & CRM Software | EnteliPro"
        description="Create your account on EnteliPro AI ERP and CRM software. Sign up to access business management tools, sales automation, and customer insights."
        keywords="Register, Sign Up, Create Account, AI ERP Registration, CRM Registration, Business Software Sign Up, EnteliPro Register"
        canonical="https://www.entelipro.com/register"
        ogImage="https://www.entelipro.com/static/media/add-user.svg"
      />

      <Navbar />
      
      {/* Hidden H1 for SEO - visible to search engines but hidden visually */}  
      <h1 className="visually-hidden">Register for EnteliPro AI ERP & CRM Software</h1>  
      
      <div className="register-form">
        <div className="Image-container">
          <img
            src={addUser}
            alt="EnteliPro AI ERP and CRM Software Registration Sign Up"  
            className="Register-image"
          />
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="form-container">
            <div className="contents">
              <span className="Register-head">
                <span className="Register-heading">
                  Sign-Up for {`${project_name}`}
                </span>
              </span>
              <span className="Register-content">
                Create an Account to explore more
              </span>
            </div>
            <div className="form-content">
              <div className="form-group">
                <input
                  name="name"
                  type="text"
                  placeholder="Name"
                  className={
                    "form-control" +
                    (formik.errors.name && formik.touched.name
                      ? " is-invalid"
                      : "")
                  }
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                <div className="invalid-feedback">
                  {formik.errors.name && formik.touched.name
                    ? formik.errors.name
                    : null}
                </div>
              </div>

              <div className="form-group">
                <input
                  name="email"
                  type="email"
                  placeholder="Email"
                  className={
                    "form-control" +
                    (formik.errors.email && formik.touched.email
                      ? " is-invalid"
                      : "")
                  }
                  onChange={formik.handleChange}
                  value={formik.values.email}
                />
                <div className="invalid-feedback">
                  {formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : null}
                </div>
              </div>

              <div className="form-group">
                <div className="password-input-wrapper">
                  <input
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    className={
                      "form-control" +
                      (formik.errors.password && formik.touched.password
                        ? " is-invalid"
                        : "")
                    }
                    onChange={formik.handleChange}
                    onFocus={() => setPasswordFocused(true)}
                    onBlur={(e) => {
                      formik.handleBlur(e);
                      setPasswordFocused(false);
                    }}
                    value={formik.values.password}
                    onKeyDown={handleKeyDown}
                    onKeyUp={handleKeyUp}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword((v) => !v)}
                    tabIndex={-1}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                {capsLockOn && (
                  <div className={"warning_register"}>
                    <strong className={"h1"}>
                      <img
                        src={logo}
                        style={{ height: "52px", width: "50px" }}
                        alt="Caps Lock Warning"  
                      />
                      Caps Lock is On!
                    </strong>
                    <p className={"h2"}>
                      Having Caps Lock on may cause you to enter your password
                      incorrectly.
                    </p>
                    <br></br>
                    <p className={"h2"}>
                      You should press Caps Lock to turn it off before entering
                      your password.
                    </p>
                  </div>
                )}
                {/* Password Strength Indicator */}
                <div className="password-strength-wrapper">
                  {(passwordFocused || formik.values.password) &&
                    passwordRequirements.filter((req) =>
                      req.test(formik.values.password)
                    ).length < 5 && (
                    <div className="password-strength-container">
                      <div className="password-strength-bar">
                        <div
                          className={`password-strength-fill strength-${
                            passwordRequirements.filter((req) =>
                              req.test(formik.values.password)
                            ).length
                          }`}
                        ></div>
                      </div>
                      <p className="password-strength-label">
                        {(() => {
                          const met = passwordRequirements.filter((req) =>
                            req.test(formik.values.password)
                          ).length;
                          if (met === 0) return "";
                          if (met <= 2) return "Weak";
                          if (met <= 4) return "Moderate";
                          return "Strong";
                        })()}
                      </p>
                      <ul className="password-requirements-list">
                        {passwordRequirements.map((req) => {
                          const passed = req.test(formik.values.password);
                          return (
                            <li
                              key={req.key}
                              className={passed ? "req-met" : "req-unmet"}
                            >
                              <FontAwesomeIcon
                                icon={passed ? faCheck : faXmark}
                                className="req-icon"
                              />
                              {req.label}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
                <div className="invalid-feedback">
                  {formik.errors.password && formik.touched.password
                    ? formik.errors.password
                    : null}
                </div>
              </div>

              <div className="form-group">
                <div className="password-input-wrapper">
                  <input
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    className={
                      "form-control" +
                      (formik.errors.confirmPassword &&
                      formik.touched.confirmPassword
                        ? " is-invalid"
                        : "")
                    }
                    onChange={formik.handleChange}
                    value={formik.values.confirmPassword}
                    onKeyDown={handleKeyDownregister}
                    onKeyUp={handleKeyUpregister}
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowConfirmPassword((v) => !v)}
                    tabIndex={-1}
                    aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                  >
                    <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
                {capsLockonregister && (
                  <div className={"warning"}>
                    <strong className={"h1"}>
                      <img
                        src={logo}
                        style={{ height: "52px", width: "50px" }}
                        alt="Caps Lock Warning"  
                      />
                      Caps Lock is On!
                    </strong>
                    <p className={"h2"}>
                      Having Caps Lock on may cause you to enter your password
                      incorrectly.
                    </p>
                    <br></br>
                    <p className={"h2"}>
                      You should press Caps Lock to turn it off before entering
                      your password.
                    </p>
                  </div>
                )}
                <div className="invalid-feedback">
                  {formik.errors.confirmPassword &&
                  formik.touched.confirmPassword
                    ? formik.errors.confirmPassword
                    : null}
                </div>
              </div>

              <h6>Captcha Code</h6>

              <div className="form-group">
                <div className="captcha">
                  <div className="captcha-container">
                    <input
                      name="showcaptcha"
                      type="text"
                      className="form-control captcha-show"
                      value={captchaCode}
                      readOnly
                    />
                  </div>
                  <div className="reload-container">
                    <button
                      type="button"
                      className="refresh-captcha"
                      onClick={handleReloadCaptcha}
                    >
                      <FontAwesomeIcon icon={faRepeat} />
                    </button>
                  </div>
                </div>
                <input
                  name="captcha"
                  type="text"
                  placeholder="Enter Captcha"
                  className={
                    "form-control" +
                    (formik.errors.captcha && formik.touched.captcha
                      ? " is-invalid"
                      : "")
                  }
                  onChange={formik.handleChange}
                  value={formik.values.captcha}
                />
                <div className="invalid-feedback">
                  {formik.errors.captcha && formik.touched.captcha
                    ? formik.errors.captcha
                    : null}
                </div>
              </div>
            </div>

            <div className="buttons-container">
              <div className="button-wrap">
                <button type="submit" className="Register-buttons">
                  Register
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}